module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrong"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("答对四题拼红包")]), _vm._v(" "), _c('img', {
    staticClass: "wrong_top_img",
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E7%AD%94%E9%94%99%E4%BA%86-%E5%A4%B4%E9%83%A8@2x_03.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p1 p2"
  }, [_vm._v("好遗憾，答错了")]), _vm._v(" "), (_vm.integral < 1) ? _c('p', {
    staticClass: "p1 p3"
  }, [_vm._v("整理心情，明天继续加油吧~")]) : (_vm.integral > 0) ? _c('p', {
    staticClass: "p1 p3"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E7%AD%94%E9%94%99%E4%BA%86-%E7%A7%AF%E5%88%86@2x.png",
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.integral) + "积分鼓励奖已经放入你的账户")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    on: {
      "click": _vm.jump
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "b_mid"
  }, [_c('div', {
    staticClass: "b_m_a"
  }, [_c('div', {
    staticClass: "b_m_a_b"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/err-t.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {}, [_c('p', {
    staticClass: "b_b_p1"
  }, [_vm._v(_vm._s(_vm.courseObj.title))]), _vm._v(" "), _c('p', {
    staticClass: "b_b_p2"
  }, [_vm._v("正解: " + _vm._s(_vm.courseObj.correctAnswer))])])])]), _vm._v(" "), _c('div', {
    staticClass: "video_box"
  }, [_c('img', {
    staticClass: "video_pic",
    attrs: {
      "src": _vm.courseObj.pic1,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video_right"
  }, [_c('p', {
    staticClass: "video_title"
  }, [_vm._v(_vm._s(_vm.courseObj.course_name))]), _vm._v(" "), _c('p', {
    staticClass: "video_bottom"
  }, [_c('span', [_vm._v(_vm._s(_vm.courseObj.FULL_NAME))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.courseObj.DUTIES))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b_top"
  }, [_c('p', {
    staticClass: "p4"
  }, [_vm._v("快去看看这道题的正解")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3ac6e42e"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/Wrong/index.vue
// module id = 236
// module chunks = 1